export default "__VITE_ASSET__DW1oBMr1__"